(() => {
  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const initHelpCenter = (root) => {
    if (!root || root.dataset.helpReady === 'true') return;
    root.dataset.helpReady = 'true';

    const form = root.querySelector('[data-help-search-form]');
    const input = root.querySelector('[data-help-search]');
    const clear = root.querySelector('[data-help-clear]');
    const summary = root.querySelector('[data-help-summary]');
    const empty = root.querySelector('[data-help-empty]');
    const categorySection = root.querySelector('[data-help-categories]');
    const items = Array.from(root.querySelectorAll('[data-help-item]'));
    const groups = Array.from(root.querySelectorAll('[data-help-group]'));

    groups.forEach((group) => {
      const groupItems = Array.from(group.querySelectorAll('[data-help-item]'));
      const viewAll = group.querySelector('[data-help-view-all]');
      groupItems.forEach((item, index) => {
        item.hidden = index >= 3;
        item.dataset.helpInitiallyHidden = String(index >= 3);
      });

      if (!viewAll) return;
      viewAll.hidden = groupItems.length <= 3;
      viewAll.addEventListener('click', () => {
        const expanded = viewAll.getAttribute('aria-expanded') === 'true';
        viewAll.setAttribute('aria-expanded', String(!expanded));
        viewAll.textContent = expanded ? `View all (${groupItems.length})` : 'Show fewer';
        groupItems.forEach((item, index) => {
          item.hidden = expanded && index >= 3;
        });
      });
      viewAll.textContent = `View all (${groupItems.length})`;
      viewAll.setAttribute('aria-expanded', 'false');
    });

    root.querySelectorAll('[data-help-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const answer = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!answer) return;

        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(willOpen));
        answer.hidden = !willOpen;
      });
    });

    const filterQuestions = () => {
      const query = normalize(input.value);
      const terms = query.split(' ').filter(Boolean);
      let visibleCount = 0;

      items.forEach((item) => {
        const haystack = normalize(item.dataset.searchText);
        const matches = terms.every((term) => haystack.includes(term));
        const group = item.closest('[data-help-group]');
        const expanded = group?.querySelector('[data-help-view-all]')?.getAttribute('aria-expanded') === 'true';
        const initiallyHidden = item.dataset.helpInitiallyHidden === 'true';
        item.hidden = terms.length > 0 ? !matches : (initiallyHidden && !expanded);
        if (matches) visibleCount += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-help-item]:not([hidden])');
        const viewAll = group.querySelector('[data-help-view-all]');
        if (viewAll) viewAll.hidden = terms.length > 0 || group.querySelectorAll('[data-help-item]').length <= 3;
      });

      clear.hidden = query.length === 0;
      empty.hidden = visibleCount > 0;
      if (categorySection) categorySection.hidden = query.length > 0;

      if (!query) {
        summary.textContent = '';
      } else if (visibleCount === 1) {
        summary.textContent = '1 answer found';
      } else {
        summary.textContent = `${visibleCount} answers found`;
      }
    };

    form.addEventListener('submit', (event) => event.preventDefault());
    input.addEventListener('input', filterQuestions);
    input.addEventListener('search', filterQuestions);
    clear.addEventListener('click', () => {
      input.value = '';
      filterQuestions();
      input.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-ks-help-center]').forEach(initHelpCenter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
